module.exports = __webpack_public_path__ + "images/arrow-upbb00a0d74b607bc15fa4c75097d381c9.png";